import script from "./ElementOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOutline.vue?vue&type=style&index=0&id=18fbbd33&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18fbbd33"]])

export default __exports__